import {defineMessages} from "react-intl";

export default defineMessages({
    listenToIvr: { id: "ivr.listenToIvr", defaultMessage: "Listen to IVR audio file", description: 'IVR: Listen to IVR audio file' },
})